import React from 'react';

/**
 * Policy name template with fallback
 */
export const PolicyNameTemplate: React.FC<{ name?: string | null }> = ({ name }) => {
  return <span>{name || 'Unnamed Policy'}</span>;
};

export default PolicyNameTemplate;
